const PLANET_TEXTURE_BASE =
  "https://cdn.jsdelivr.net/gh/mrdoob/three.js@r162/examples/textures/planets";

export const planets = [
  {
    id: "mercury",
    name: "Mercury",
    image: `${PLANET_TEXTURE_BASE}/mercury.jpg`,
    color: "#9aa3b2",
  },
  {
    id: "venus",
    name: "Venus",
    image: `${PLANET_TEXTURE_BASE}/venus.jpg`,
    color: "#ff9c42",
  },
  {
    id: "earth",
    name: "Earth",
    image: `${PLANET_TEXTURE_BASE}/earth_atmos_2048.jpg`,
    color: "#2f7bff",
  },
  {
    id: "mars",
    name: "Mars",
    image: `${PLANET_TEXTURE_BASE}/mars_1k_color.jpg`,
    color: "#ff604a",
  },
  {
    id: "jupiter",
    name: "Jupiter",
    image: `${PLANET_TEXTURE_BASE}/jupiter.jpg`,
    color: "#f6b36a",
  },
  {
    id: "saturn",
    name: "Saturn",
    image: `${PLANET_TEXTURE_BASE}/saturn.jpg`,
    color: "#f1d08a",
  },
  {
    id: "uranus",
    name: "Uranus",
    image: `${PLANET_TEXTURE_BASE}/uranus.jpg`,
    color: "#4bd4ff",
  },
  {
    id: "pluto",
    name: "Pluto",
    image: `${PLANET_TEXTURE_BASE}/pluto.jpg`,
    color: "#b68cff",
  },
];
